// extracted by css-extract-rspack-plugin
export default {"Box":"y-axis-selector-module__Box__WEJ5u","SelectorLabel":"y-axis-selector-module__SelectorLabel__pTvKf","ActionMenu_Button":"y-axis-selector-module__ActionMenu_Button__vF1h7"};